import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { RequestService } from './request.service';
import { CommonResponse } from '../models/responses/common-response';

@Injectable({
	providedIn: 'root',
})
export class ReceiveBranchNoteService {
	private path: string = 'branch-note-receive';

	constructor(private requestService: RequestService) {}

	getNewCount(): Observable<CommonResponse<any>> {
		return this.requestService.getJSON(`/${this.path}/count-new`, {
			data: {},
			option: {
				is_loading: false,
			},
		});
	}

	getList(data?: any) {
		return this.requestService.postJSON(`/${this.path}`, {
			data,
			option: {
				is_loading: true,
			},
		});
	}

	getByID(id?: string): Observable<CommonResponse<any>> {
		return this.requestService.getJSON(`/${this.path}/${id}`, {
			data: {},
			option: {
				is_loading: true,
			},
		});
	}

	save(payload: any): Observable<CommonResponse<any>> {
		return this.requestService.postJSON(`/${this.path}/save`, {
			data: payload,
			option: {
				is_loading: true,
				is_snack_bar: true,
			},
		});
	}

	getHistory(id: string): Observable<CommonResponse<any>> {
		return this.requestService.getJSON(`/${this.path}/history/${id}`, {
			data: {},
			option: {
				is_loading: true,
			},
		});
	}

	createHistory(status: string, data: any): Observable<CommonResponse<any>> {
		return this.requestService.postJSON(
			`/${this.path}/history/${status}`,
			{
				data,
				option: {
					is_loading: true,
				},
			},
			true,
		);
	}

	//UPLOAD DOCUMENT ======================================================
	uploadDoc(doc: FileList, type: any): Observable<CommonResponse<any>> {
		const formData = new FormData();
		for (let i = 0; i < doc.length; i++) {
			formData.append('file', doc[i]);
		}
		formData.append('type', type);
		return this.requestService.postData(`/${this.path}/attachment`, {
			data: formData,
			option: {
				is_loading: true,
			},
		});
	}

	//GET ATTACHMENT ======================================================
	getAttachment(id: string): Observable<Blob> {
		return this.requestService.get(
			`/${this.path}/attachment/${id}`,
			{
				data: null,
				option: {
					is_loading: true,
				},
			},
			'blob',
		);
	}

	deleteDocument(id: string, loading = true) {
		return this.requestService
			.deleteJSON(`/${this.path}/attachment/${id}/delete`, {
				data: {},
				option: {
					is_loading: loading,
				},
			})
			.pipe(
				map((response) => {
					const data = Object.assign(response, { data: { _id: id } });
					return data;
				}),
			);
	}

	delete(id: string): Observable<CommonResponse<any>> {
		return this.requestService.deleteJSON(
			`/${this.path}/${id}/delete`,
			{
				data: {},
				option: {
					is_loading: true,
				},
			},
			true,
		);
	}

	submit(_id: string): Observable<CommonResponse<any>> {
		return this.requestService.postJSON(
			`/${this.path}/submit/${_id}`,
			{
				option: {
					is_loading: true,
					is_snack_bar: true,
				},
			},
			true,
		);
	}

	getRecords(data?: any): Observable<CommonResponse<any>> {
		return this.requestService.postJSON(`/overall-note/records`, {
			data,
			option: {
				is_loading: true,
			},
		});
	}
	getMember(data?: any): Observable<CommonResponse<any>> {
		return this.requestService.postJSON(`/${this.path}/members`, {
			data,
			option: {
				is_loading: true,
			},
		});
	}

	getPrintByID(id?: string): Observable<CommonResponse<any>> {
		return this.requestService.getJSON(`/${this.path}/print/${id}`, {
			data: {},
			option: {
				is_loading: true,
			},
		});
	}

	validateMember(data?: any): Observable<CommonResponse<any>> {
		return this.requestService.postJSON(`/${this.path}/validation`, {
			data,
			option: {
				is_loading: true,
			},
		});
	}

	getOverallNoteRecords(data?: any): Observable<CommonResponse<any>> {
		return this.requestService.postJSON(`/${this.path}/records`, {
			data,
			option: {
				is_loading: true,
			},
		});
	}

	addMember(payload: any): Observable<CommonResponse<any>> {
		return this.requestService.postJSON(`/${this.path}/member/add`, {
			data: payload,
			option: {
				is_loading: true,
				is_snack_bar: true,
			},
		});
	}

	removeMember(payload: any): Observable<CommonResponse<any>> {
		return this.requestService.postJSON(`/${this.path}/member/remove`, {
			data: payload,
			option: {
				is_loading: true,
				is_snack_bar: true,
			},
		});
	}

	removeRecord(_id: string): Observable<CommonResponse<any>> {
		return this.requestService.deleteJSON(
			`/${this.path}/record/${_id}/delete`,
			{
				data: {},
				option: {
					is_loading: true,
				},
			},
			true,
		);
	}

	exportExcel(
		id?: string,
		data?: { benGroup: string; bank: string },
	): Observable<CommonResponse<any>> {
		return this.requestService.postJSON(`/${this.path}/export/${id}`, {
			data,
			option: {
				is_loading: true,
			},
		});
	}

	changeStatusRecord(
		status: string,
		data: any,
	): Observable<CommonResponse<any>> {
		return this.requestService.postJSON(
			`/${this.path}/record/${status}`,
			{
				data,
				option: {
					is_loading: true,
				},
			},
			true,
		);
	}

	markasAcceptRecord(data: any): Observable<CommonResponse<any>> {
		return this.requestService.postJSON(
			`/${this.path}/record/confirm`,
			{
				data,
				option: {
					is_loading: true,
					is_snack_bar: true,
				},
			},
			true,
		);
	}

	markAsCorrection(data: any): Observable<CommonResponse<any>> {
		return this.requestService.postJSON(
			`/${this.path}/record/correction`,
			{
				data,
				option: {
					is_loading: true,
					is_snack_bar: true,
				},
			},
			true,
		);
	}

	export(data?: any): Observable<CommonResponse<any>> {
		return this.requestService.postJSON(`/${this.path}/report`, {
			data,
			option: {
				is_loading: false,
			},
		});
	}
}
